/**
 * Find the most applicable onboarding policy for org-level candidate data.
 */
export function findApplicableOnboardingPolicy(
  orgData = {},
  policies = [],
  referenceDate = null
) {
  if (!policies || policies.length === 0) return null;

  const refDate = referenceDate ? new Date(referenceDate) : new Date();
  refDate.setHours(0, 0, 0, 0);

  const eligiblePolicies = policies.filter((policy) => {
    if (policy.status !== "active") return false;
    if (policy.effectiveDate) {
      const effectiveDate = new Date(policy.effectiveDate);
      effectiveDate.setHours(0, 0, 0, 0);
      if (effectiveDate > refDate) return false;
    }
    return true;
  });

  const matchingPolicies = eligiblePolicies.filter((policy) => {
    const assignedTo = policy.assignedTo || {};
    if (assignedTo.allEmployees) return true;

    const checks = [
      assignedTo.branches?.length > 0 &&
        assignedTo.branches.includes(Number(orgData.branchId)),
      assignedTo.departments?.length > 0 &&
        assignedTo.departments.includes(Number(orgData.departmentId)),
      assignedTo.designations?.length > 0 &&
        assignedTo.designations.includes(Number(orgData.designationId)),
      assignedTo.grades?.length > 0 &&
        assignedTo.grades.includes(Number(orgData.gradeId)),
      assignedTo.categories?.length > 0 &&
        assignedTo.categories.includes(Number(orgData.categoryId)),
      assignedTo.subDepartments?.length > 0 &&
        assignedTo.subDepartments.includes(Number(orgData.subDepartmentId)),
      assignedTo.employmentTypes?.length > 0 &&
        assignedTo.employmentTypes.includes(orgData.employmentType),
    ];
    return checks.some(Boolean);
  });

  if (matchingPolicies.length === 0) return null;

  matchingPolicies.sort((a, b) => {
    const dateA = new Date(a.effectiveDate || 0).getTime();
    const dateB = new Date(b.effectiveDate || 0).getTime();
    return dateB - dateA;
  });

  return matchingPolicies[0];
}
